export default function BrandIntro() {
  return (
    <section className="mb-14">
      <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading mb-6">
        品牌介绍
      </h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        <div>
          <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-4">
            嫩草影院成立于2020年，是一家专注于在线影视内容聚合与分发的互联网平台。我们致力于为广大影视爱好者提供最便捷、最高清、最全面的观影体验。
          </p>
          <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-4">
            平台汇聚了海量电影、电视剧、动漫、综艺、纪录片等优质影视资源，涵盖国内外热门影片。无论是院线大片、经典老片还是小众佳作，在嫩草影院都能找到。
          </p>
          <p className="text-sm md:text-base text-foreground-300 leading-relaxed">
            我们始终坚持"用户至上、内容为王"的理念，不断优化平台技术，提升观影体验。从视频加载速度到画质清晰度，从界面设计到内容推荐，每一个细节都倾注了团队的用心。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3">
          {[
            { label: '影片总量', value: '50,000+' },
            { label: '日均更新', value: '100+' },
            { label: '月活用户', value: '500万+' },
            { label: '好评率', value: '98%' },
          ].map((stat) => (
            <div
              key={stat.label}
              className="p-5 rounded-lg bg-background-200/40 border border-background-200/20 text-center"
            >
              <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading mb-1">
                {stat.value}
              </div>
              <div className="text-xs text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}